export default __webpack_public_path__ + "static/media/kapcsolat.e8c7424d.svg";